export default __webpack_public_path__ + "static/media/ipl_4.9714adf8.png";